module.exports = __webpack_public_path__ + "static/media/Adam.b607d700.jpg";